var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({ padding: '200px 100px' })},[_c('div',[_c('h4',[_vm._v("PDF Uploader")]),_c('PDFUploader',{attrs:{"update":_vm.documentsUpdated}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }